// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type Options as Options2, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AuthCookieLoginData, AuthCookieLoginErrors, AuthCookieLoginResponses, AuthCookieLogoutData, AuthCookieLogoutErrors, AuthCookieLogoutResponses, CatchAllData, CatchAllResponses, DocumentArchiveData, DocumentArchiveErrors, DocumentArchiveListData, DocumentArchiveListErrors, DocumentArchiveListResponses, DocumentArchiveResponses, DocumentCreateData, DocumentCreateErrors, DocumentCreateResponses, DocumentListData, DocumentListErrors, DocumentListResponses, DocumentReadData, DocumentReadErrors, DocumentReadPublicData, DocumentReadPublicErrors, DocumentReadPublicResponses, DocumentReadResponses, DocumentShareData, DocumentShareErrors, DocumentShareResponses, DocumentUnarchiveData, DocumentUnarchiveErrors, DocumentUnarchiveResponses, DocumentUpdateData, DocumentUpdateErrors, DocumentUpdateResponses, OauthGoogleCookieAuthorizeData, OauthGoogleCookieAuthorizeErrors, OauthGoogleCookieAuthorizeResponses, OauthGoogleCookieCallbackData, OauthGoogleCookieCallbackErrors, OauthGoogleCookieCallbackResponses, RedirectToStyleguideRootData, RedirectToStyleguideRootResponses, RegisterRegisterData, RegisterRegisterErrors, RegisterRegisterResponses, ResetForgotPasswordData, ResetForgotPasswordErrors, ResetForgotPasswordResponses, ResetResetPasswordData, ResetResetPasswordErrors, ResetResetPasswordResponses, UsersCurrentUserData, UsersCurrentUserErrors, UsersCurrentUserResponses, UsersDeleteUserData, UsersDeleteUserErrors, UsersDeleteUserResponses, UsersPatchCurrentUserData, UsersPatchCurrentUserErrors, UsersPatchCurrentUserResponses, UsersPatchUserData, UsersPatchUserErrors, UsersPatchUserResponses, UsersUserData, UsersUserErrors, UsersUserResponses, VerifyRequestTokenData, VerifyRequestTokenErrors, VerifyRequestTokenResponses, VerifyVerifyData, VerifyVerifyErrors, VerifyVerifyResponses, VersionArchiveData, VersionArchiveErrors, VersionArchiveResponses, VersionCreateData, VersionCreateErrors, VersionCreateResponses, VersionListData, VersionListErrors, VersionListResponses, VersionReadData, VersionReadErrors, VersionReadPublicData, VersionReadPublicErrors, VersionReadPublicResponses, VersionReadResponses, VersionShareData, VersionShareErrors, VersionShareResponses, VersionUnarchiveData, VersionUnarchiveErrors, VersionUnarchiveResponses, VersionUpdateData, VersionUpdateErrors, VersionUpdateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Auth:Cookie.Login
 */
export const authCookieLogin = <ThrowOnError extends boolean = false>(options: Options<AuthCookieLoginData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthCookieLoginResponses, AuthCookieLoginErrors, ThrowOnError, 'data'>({
        ...urlSearchParamsBodySerializer,
        responseStyle: 'data',
        url: '/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...options.headers
        }
    });
};

/**
 * Auth:Cookie.Logout
 */
export const authCookieLogout = <ThrowOnError extends boolean = false>(options?: Options<AuthCookieLogoutData, ThrowOnError>) => {
    return (options?.client ?? client).post<AuthCookieLogoutResponses, AuthCookieLogoutErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/auth/logout',
        ...options
    });
};

/**
 * Verify:Request-Token
 */
export const verifyRequestToken = <ThrowOnError extends boolean = false>(options: Options<VerifyRequestTokenData, ThrowOnError>) => {
    return (options.client ?? client).post<VerifyRequestTokenResponses, VerifyRequestTokenErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        url: '/auth/request-verify-token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Verify:Verify
 */
export const verifyVerify = <ThrowOnError extends boolean = false>(options: Options<VerifyVerifyData, ThrowOnError>) => {
    return (options.client ?? client).post<VerifyVerifyResponses, VerifyVerifyErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        url: '/auth/verify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Register:Register
 */
export const registerRegister = <ThrowOnError extends boolean = false>(options: Options<RegisterRegisterData, ThrowOnError>) => {
    return (options.client ?? client).post<RegisterRegisterResponses, RegisterRegisterErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        url: '/auth/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Reset:Forgot Password
 */
export const resetForgotPassword = <ThrowOnError extends boolean = false>(options: Options<ResetForgotPasswordData, ThrowOnError>) => {
    return (options.client ?? client).post<ResetForgotPasswordResponses, ResetForgotPasswordErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        url: '/auth/forgot-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Reset:Reset Password
 */
export const resetResetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetResetPasswordData, ThrowOnError>) => {
    return (options.client ?? client).post<ResetResetPasswordResponses, ResetResetPasswordErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        url: '/auth/reset-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Oauth:Google.Cookie.Authorize
 */
export const oauthGoogleCookieAuthorize = <ThrowOnError extends boolean = false>(options?: Options<OauthGoogleCookieAuthorizeData, ThrowOnError>) => {
    return (options?.client ?? client).get<OauthGoogleCookieAuthorizeResponses, OauthGoogleCookieAuthorizeErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        url: '/auth/google/authorize',
        ...options
    });
};

/**
 * Oauth:Google.Cookie.Callback
 * The response varies based on the authentication backend used.
 */
export const oauthGoogleCookieCallback = <ThrowOnError extends boolean = false>(options?: Options<OauthGoogleCookieCallbackData, ThrowOnError>) => {
    return (options?.client ?? client).get<OauthGoogleCookieCallbackResponses, OauthGoogleCookieCallbackErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        url: '/auth/google/callback',
        ...options
    });
};

/**
 * Users:Current User
 */
export const usersCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<UsersCurrentUserData, ThrowOnError>) => {
    return (options?.client ?? client).get<UsersCurrentUserResponses, UsersCurrentUserErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/auth/me',
        ...options
    });
};

/**
 * Users:Patch Current User
 */
export const usersPatchCurrentUser = <ThrowOnError extends boolean = false>(options: Options<UsersPatchCurrentUserData, ThrowOnError>) => {
    return (options.client ?? client).patch<UsersPatchCurrentUserResponses, UsersPatchCurrentUserErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/auth/me',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Users:Delete User
 */
export const usersDeleteUser = <ThrowOnError extends boolean = false>(options: Options<UsersDeleteUserData, ThrowOnError>) => {
    return (options.client ?? client).delete<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/auth/{id}',
        ...options
    });
};

/**
 * Users:User
 */
export const usersUser = <ThrowOnError extends boolean = false>(options: Options<UsersUserData, ThrowOnError>) => {
    return (options.client ?? client).get<UsersUserResponses, UsersUserErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/auth/{id}',
        ...options
    });
};

/**
 * Users:Patch User
 */
export const usersPatchUser = <ThrowOnError extends boolean = false>(options: Options<UsersPatchUserData, ThrowOnError>) => {
    return (options.client ?? client).patch<UsersPatchUserResponses, UsersPatchUserErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/auth/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Document List
 */
export const documentList = <ThrowOnError extends boolean = false>(options?: Options<DocumentListData, ThrowOnError>) => {
    return (options?.client ?? client).get<DocumentListResponses, DocumentListErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/documents/',
        ...options
    });
};

/**
 * Document Create
 */
export const documentCreate = <ThrowOnError extends boolean = false>(options: Options<DocumentCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<DocumentCreateResponses, DocumentCreateErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/documents/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Document Archive List
 */
export const documentArchiveList = <ThrowOnError extends boolean = false>(options?: Options<DocumentArchiveListData, ThrowOnError>) => {
    return (options?.client ?? client).get<DocumentArchiveListResponses, DocumentArchiveListErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/documents/archive/',
        ...options
    });
};

/**
 * Document Archive
 */
export const documentArchive = <ThrowOnError extends boolean = false>(options: Options<DocumentArchiveData, ThrowOnError>) => {
    return (options.client ?? client).delete<DocumentArchiveResponses, DocumentArchiveErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/documents/{id}/',
        ...options
    });
};

/**
 * Document Read
 */
export const documentRead = <ThrowOnError extends boolean = false>(options: Options<DocumentReadData, ThrowOnError>) => {
    return (options.client ?? client).get<DocumentReadResponses, DocumentReadErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/documents/{id}/',
        ...options
    });
};

/**
 * Document Update
 */
export const documentUpdate = <ThrowOnError extends boolean = false>(options: Options<DocumentUpdateData, ThrowOnError>) => {
    return (options.client ?? client).put<DocumentUpdateResponses, DocumentUpdateErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/documents/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Document Read Public
 */
export const documentReadPublic = <ThrowOnError extends boolean = false>(options: Options<DocumentReadPublicData, ThrowOnError>) => {
    return (options.client ?? client).get<DocumentReadPublicResponses, DocumentReadPublicErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        url: '/api/documents/public/{public_id}/',
        ...options
    });
};

/**
 * Document Share
 * Enable or disable sharing on a document via public link.
 */
export const documentShare = <ThrowOnError extends boolean = false>(options: Options<DocumentShareData, ThrowOnError>) => {
    return (options.client ?? client).post<DocumentShareResponses, DocumentShareErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/documents/{id}/share/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Document Unarchive
 */
export const documentUnarchive = <ThrowOnError extends boolean = false>(options: Options<DocumentUnarchiveData, ThrowOnError>) => {
    return (options.client ?? client).post<DocumentUnarchiveResponses, DocumentUnarchiveErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/documents/{id}/unarchive/',
        ...options
    });
};

/**
 * Version List
 */
export const versionList = <ThrowOnError extends boolean = false>(options?: Options<VersionListData, ThrowOnError>) => {
    return (options?.client ?? client).get<VersionListResponses, VersionListErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/versions/',
        ...options
    });
};

/**
 * Version Create
 */
export const versionCreate = <ThrowOnError extends boolean = false>(options: Options<VersionCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<VersionCreateResponses, VersionCreateErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/versions/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Version Archive
 */
export const versionArchive = <ThrowOnError extends boolean = false>(options: Options<VersionArchiveData, ThrowOnError>) => {
    return (options.client ?? client).delete<VersionArchiveResponses, VersionArchiveErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/versions/{id}/',
        ...options
    });
};

/**
 * Version Read
 */
export const versionRead = <ThrowOnError extends boolean = false>(options: Options<VersionReadData, ThrowOnError>) => {
    return (options.client ?? client).get<VersionReadResponses, VersionReadErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/versions/{id}/',
        ...options
    });
};

/**
 * Version Update
 */
export const versionUpdate = <ThrowOnError extends boolean = false>(options: Options<VersionUpdateData, ThrowOnError>) => {
    return (options.client ?? client).put<VersionUpdateResponses, VersionUpdateErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/versions/{id}/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Version Read Public
 */
export const versionReadPublic = <ThrowOnError extends boolean = false>(options: Options<VersionReadPublicData, ThrowOnError>) => {
    return (options.client ?? client).get<VersionReadPublicResponses, VersionReadPublicErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        url: '/api/versions/public/{public_id}/',
        ...options
    });
};

/**
 * Version Share
 * Enable or disable sharing on a version via public link.
 */
export const versionShare = <ThrowOnError extends boolean = false>(options: Options<VersionShareData, ThrowOnError>) => {
    return (options.client ?? client).post<VersionShareResponses, VersionShareErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/versions/{id}/share/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Version Unarchive
 */
export const versionUnarchive = <ThrowOnError extends boolean = false>(options: Options<VersionUnarchiveData, ThrowOnError>) => {
    return (options.client ?? client).post<VersionUnarchiveResponses, VersionUnarchiveErrors, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/api/versions/{id}/unarchive/',
        ...options
    });
};

/**
 * Redirect To Styleguide Root
 */
export const redirectToStyleguideRoot = <ThrowOnError extends boolean = false>(options?: Options<RedirectToStyleguideRootData, ThrowOnError>) => {
    return (options?.client ?? client).get<RedirectToStyleguideRootResponses, unknown, ThrowOnError, 'data'>({
        responseStyle: 'data',
        url: '/styleguide',
        ...options
    });
};

/**
 * Catch All
 * Catch-all route to provide runtime global vars and initial data to the frontend.
 */
export const catchAll = <ThrowOnError extends boolean = false>(options?: Options<CatchAllData, ThrowOnError>) => {
    return (options?.client ?? client).get<CatchAllResponses, unknown, ThrowOnError, 'data'>({
        responseStyle: 'data',
        security: [
            {
                in: 'cookie',
                name: 'fastapiusersauth',
                type: 'apiKey'
            }
        ],
        url: '/{path}',
        ...options
    });
};
